<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin-dashboard' }">
    <template #title>
      <span>{{ translateTitleCase("tracking.displayTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration" @crud-list:data-updated="listDataUpdatedHandler">
        <template #before-table>
          <div v-if="sumsBySource">
            <h4>{{ translate("tracking.totalsTitle") }}</h4>
            <div class="flex flex-wrap flex-row width-expand gap-l margin-xl-bottom">
              <div v-for="(count, key) of sumsBySource" class="sum-block">
                <strong
                  style="display: inline-block; min-width: 50px; margin-inline-end: 20px"
                  >{{ key }}:</strong
                >
                <span>{{ count }}</span>
              </div>
            </div>
            <h4 class="margin-s-bottom">{{ translate("tracking.itemDetailsTitle") }}</h4>
          </div>
        </template>
        <template #cell-createdAt="{ item }">
          {{ item.createdAt ? translateDate(item.createdAt, "dateWithTime") : "-" }}
        </template>
      </custom-crud-list>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  components: { CustomCrudList },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "tracking.pageTitle",
  data: function () {
    return {
      sumsBySource: false,
      order: false,
      userForm: false,
      listConfiguration: {
        subject: "order",
        listSrc: "justopp/tracking/source/hit",
        initialOrdering: { key: "createdAt", direction: "desc" },
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: false, //bool, default false
        enableMassActions: false,
        editRoutePrefix: "admin-",
        createRoutePrefix: "admin-",
        deleteRoutePrefix: "ecommerce/",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          // these are the table columns
          ip: {
            itemKey: "ip",
            label: "tracking.fields.ip",
            filterable: {
              name: "ip",
              type: "text",
              placeholder: "tracking.fields.ip",
            }, // boolean, or object
            quickEdit: false,
            orderable: true,
          },
          source: {
            itemKey: "source",
            label: "tracking.fields.source",
            filterable: true,
          },
          createdAt: {
            listable: true,
            filterable: false,
            type: "DatePicker",
            itemKey: "createdAt",
            label: "tracking.fields.createdAt",
          },
          createdFrom: {
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "DatePicker",
              placeholder: "tracking.fields.createdFrom",
            },
            type: "DatePicker",
            label: "tracking.fields.createdFrom",
          },
          createdBefore: {
            listable: false,
            filterable: {
              name: "createdBefore",
              type: "DatePicker",
              placeholder: "tracking.fields.createdBefore",
            },
            label: "tracking.fields.createdBefore",
          },

          // vendor filter
          // product name search
        },
        actions: {
          show: false,
          edit: false,
          delete: false,
        },
      },
      asyncData: {
        userForm: "entity/user/update",
      },
    };
  },
  computed: {
    buyerInformationList() {
      const res = [];
      //  console.log(this.userForm.fields);
      Object.entries(this.userForm.fields).forEach(([key, field]) => {
        let label;

        if (field.placeholder) {
          label = field.placeholder;
        }
        if (field.label) {
          label = field.label;
        }
        res.push({ label: label, value: this?.order?.Buyer[key] });
      });
      return res;
    },
  },
  methods: {
    listDataUpdatedHandler(eventData) {
      console.log('updated', eventData)
      if (eventData && eventData?.sums?.bySource) {
        this.sumsBySource = eventData?.sums.bySource;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
